import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import { encrypt , decrypt , getParams } from "../../../helpers/CryptoJs";
import FeedFooter from "../../FeedContainer/FeedFooter";

import { getPromotionDetail } from "../../../actions/promotionAction";
import { evcwalletPayment } from "../../../actions/evcAction";
import { getlanguagelist } from "../../../helpers/changelanguage";
import  WalletConnection  from "./walletconnection";
import Chip from '@material-ui/core/Chip';


class PromotionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
          promotionId : decrypt(window.location.href.split('/')[4]),
          modal       : false,
        };
        this.payNow     = this.payNow.bind(this);
        this.openModal  = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.evcpayment = this.evcpayment.bind(this);
    }
    componentDidMount() { 
        this.props.getPromotionDetail({'promotion_id' : this.state.promotionId});  
    }
    UNSAFE_componentWillReceiveProps(nextProps){  
        if(nextProps.evc != this.props.evc){
            this.closeModal();
            let languagelist = getlanguagelist();
            if(Object.keys(nextProps.evc).length == 0){
                ToastsStore.error(languagelist.evcwalletfailure);
            }else{
                ToastsStore.success(languagelist.evcwalletsuccess);
            }
           // this.props.history.push(`/promotion_list`)
        }
    }

    UNSAFE_componentWillUpdate(){
       /*  var scrollTop  = $(window).scrollTop(),
        elementOffset  = $('.content_block').offset().top,
        distance       = (elementOffset - scrollTop);
        if(distance > 0){
          $('.content_block').css('padding','0 0px 0px 55px');
        } */
    }

    payNow(){
        window.location.href = this.props.promotiondetail.payment_url; 
    }

    openModal(){
        this.setState({
            modal : true
        })
    }
    closeModal(){
        this.setState({
            modal : false
        })
    }
   
    evcpayment(phone){

        let param = {
            reference_id     : this.state.promotionId,
            payment_reason   : 'PROMOTION',
            phone_no         : `252${phone}`
        }
        this.props.evcwalletPayment(param);  
    }
    
    render() {
        let languagelist  = getlanguagelist();
        let details       = this.props.promotiondetail || [];
        let professions   = this.props.promotiondetail.profession_name || [];
        let hobbies       = this.props.promotiondetail.hobby_name      || [];
        let media_details = this.props.promotiondetail.media_details   || [];
        let content       = this.props.promotiondetail.promotion_description
        if((content != undefined) && (content.includes('href') == true)){
            content           = content.replace(/href='(.+?)'>/g, function(m, $1) {
                return 'href='+$1+' target="_blank" class="hyperlinkss">';
              
           })
        }
        
        return (
            <div className="content_area">
                <div className="col-lg-12">
                    <h3 className="heading_2">{languagelist.previewpromotion}:</h3>
                </div>
                <div className="clr10"></div>

                <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
                    <div className="left_fixt">
                          <div className="post_box known">
                            <h3>{languagelist.promotiondes}</h3>
                            <div className="description_box" dangerouslySetInnerHTML={{ __html: ' '+content+ ' ' }}>

                            </div>
                        </div>

                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-9 post_area">
                     <div className="row">
                    <div className="post_box">

                        <div className="clr20"></div>

                        <div className="col-lg-12">
                            <div className="infi_fild">
                                <img className="pull-left" src="/assets/images/commend_circle.png" />
                                <div className="input_mid pull-left">
                                    <label>{languagelist.promotionhead}</label>
                                    
                                    <div className="clr10"></div>
                                    {this.props.promotiondetail.promotion_name}
                                   

                                 
                                </div>
                                  <div className="input_mid pull-right promotion-reaction" style={{width : '400px'}}>
                                   {(details.total_reaction != undefined) ?
                                    <FeedFooter 
                                        total_reaction={details.total_reaction} 
                                        my_reaction={details.my_reaction}
                                        total_comment={details.total_comment} 
                                        total_share="" 
                                        data_type="Promotion" 
                                        feed_id=""
                                        post_id={details.id}
                                        position="feed" 
                                        feed_reaction_details = {details.feed_reaction_details}
                                    /> 
                                    : null 
                                   }
                                  </div>
                                <div className="clearfix"></div>
                            </div>
                            <div className="clr10"></div>
                            <GridList cellHeight={160} cols={3}>
                                {media_details.map((file,index) => (
                                    <GridListTile key={`list_${index}`} cols={1} id={`list_${index}`}>
                                        {
                                        (file.media_type.includes("IMAGE")) ? 
                                        <img src={file.media_link} alt={file.media_link} 
                                          onError = {(e) => {
                                            e.target.src = iconHelper['BREAKIMAGE']
                                          }}
                                        />
                                        : 
                                        <video controls className="video-player" controlsList="nodownload">
                                            <source src={file.media_link} alt={file.media_link} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video> 
                                        }
                                        
                                    </GridListTile>
                                ))}
                            </GridList>
                          
                        </div>


                        <div className="clr20"></div>
                    </div>


                    {
                        ((this.props.promotiondetail.filter_by_recent_reg == "Yes") && (this.props.currentUserDetails.user.id == this.props.promotiondetail.promotion_creator_id)) ? 
                        <div className="post_box pad_15">
                        

                            <label >{languagelist.selection}  </label>
                            <Chip label={this.props.promotiondetail.rcnt_reg_filter_type} variant="outlined" />
                            
                        </div>
                        : null 
                    }
                    </div>
                    
                </div>


                {
                (this.props.currentUserDetails.user.id == this.props.promotiondetail.promotion_creator_id) ?    
                <div className="col-lg-12">
                    <div className="row">

                        <div className="col-lg-3" style={(this.props.promotiondetail.filter_by_recent_reg == 'No') ? {display:'block'} : {display:'none'}}>
                            <div className="post_box known">
                                <div className="post_box_padd_slider">
                                    <div className="text-center">
                                       
                                        <img src="/assets/images/age_group_icon.png" />
                                        <h4>{languagelist.agegrp} </h4>
                                        <div className="clr20"></div>
                                            <div className="button_shape">
                                                <Chip label={`${this.props.promotiondetail.start_age} to ${this.props.promotiondetail.end_age}`} variant="outlined" />
                                            </div>
                                       {/*  <input type="range" min="1" max="100" value="50" onChange={this.onChange}/> */}
                                       {/* <AgeSlider start_age={this.state.start_age} end_age={this.state.end_age} onSliderChange={this.onSliderChange} onChange={this.onChange}/> */}
                                        
                                   </div>
                                   
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-3" style={(this.props.promotiondetail.filter_by_recent_reg == 'No')  ? {display:'block'} : {display:'none'}}>
                            <div className="row">
                                <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/hobby_icon.png" />
                                        <h4>{languagelist.promotionprof}</h4>
                                        <div className="clr20"></div>

                                        {
                                            professions.map( (profession,index) => {
                                                return (
                                                    <div className="button_shape" key={`professionsdiv_${index}`}>
                                                    <Chip label={profession.category_name} variant="outlined" key={`professions_${index}`}/>
                                                    <div className="clr20"></div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>

                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="col-lg-3" style={(this.props.promotiondetail.filter_by_recent_reg == 'No')  ? {display:'block'} : {display:'none'}}>
                            <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                       
                                        <img src="/assets/images/gesder_icon.png" />
                                        <h4>{languagelist.gender}</h4>
                                        <div className="clr20"></div>
                                            <div className="button_shape" >
                                             <Chip label={this.props.promotiondetail.gender} variant="outlined" />
                                            </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3" style={(this.props.promotiondetail.filter_by_recent_reg == 'No')  ? {display:'block'} : {display:'none'}}>
                            <div className="row">
                                <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/cuntry_icon.png" />
                                        <h4>{languagelist.country}</h4>
                                        <div className="clr20"></div>
                                            <div className="button_shape">
                                                {
                                                    (this.props.promotiondetail.country_name != null) ?
                                                    <Chip label={this.props.promotiondetail.country_name} variant="outlined" /> 
                                                    : null 
                                                }
                                                
                                            </div>
                                    </div>

                                </div>
                            </div>
                            </div>
                        </div>


                    </div>
                   
                        <div className={(this.props.promotiondetail.filter_by_recent_reg == 'No')  ? 'row' : 'row div-bottom'} >
                        <div className="col-lg-3" style={(this.props.promotiondetail.filter_by_recent_reg == 'No')  ? {display:'block'} : {display:'none'}}>
                            <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/hobby_icon.png" />
                                        <h4>{languagelist.hobbies}</h4>
                                        <div className="clr20"></div>
                                        {
                                            hobbies.map( (hobby,index) => {
                                                return (
                                                    <div className="button_shape" key={`hobbysdiv_${index}`}>
                                                        <Chip label={hobby.category_name} variant="outlined" key={`hobbys_${index}`}/>
                                                    <div className="clr20"></div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={(this.props.promotiondetail.filter_by_recent_reg == 'No')  ? "col-lg-9" : "col-lg-12"}>
                            <div className="row">
                                <div className="post_box known">
                                <div className="post_box_padd">
                                    <div className="text-center">
                                        
                                        <img src="/assets/images/calendar_icon.png" />
                                        <h4>{languagelist.durabudget}</h4>
                                        <div className="clr20"></div>
                                    </div>
                                    <div className="col-lg-6" style={{paddingRight :'40px'}}>
                                        <div className="row">
                                            <div className="col-lg-5 date-show" >
                                                <span style={{color : '#4189DD'}}><i className="fa fa-calendar" aria-hidden="true"></i> {moment(this.props.promotiondetail.start_date).format('MMM Do YYYY')}</span>
                                               
                                            </div>
                                            <div className="col-lg-2">
                                                <span>{languagelist.to}</span>
                                            </div>
                                            <div className="col-lg-5 date-show">
                                                <span style={{color : '#4189DD'}}><i className="fa fa-calendar" aria-hidden="true"></i> {moment(this.props.promotiondetail.end_date).format('MMM Do YYYY')}</span>
                                             
                                            </div>
                                            <div className="col-lg-12">
                                                <span className="rdays">{languagelist.budget}</span>
                                            </div>
                                            <div className="col-lg-5">
                                                 <a href="#" className="line_box line_box_active_2 btn-block"> {this.props.promotiondetail.total_days} {languagelist.days} </a>
                                            </div>
                                            <div className="col-lg-1 text-center">
                                                <div className="row"> <p className="price_sim">$</p></div>
                                            </div>
                                            <div className="col-lg-5">
                                              
                                              <input className="line_box line_box_active btn-block price_input" type="number" name="base_cost" value={this.props.promotiondetail.total_budget} readOnly />
                                            </div>
                                            <div className="col-lg-12">
                                                <span className="rdays"><i className="fa fa-clock" aria-hidden="true"></i> {languagelist.remaindays}</span>
                                            </div>
                                            <div className="col-lg-12">
                                                <span  className="ldays">{this.props.promotiondetail.remaining_days}  {languagelist.daysleft}</span>
                                            </div>
                                            <div className="col-lg-12">
                                                <span className="rdays"> <img src="/assets/images/price_icon.png" /> {languagelist.paymentmode}</span>
                                            </div>
                                            <div className="col-lg-12">
                                                <span  className="ldays">{(this.props.promotiondetail.budget_type == "Free") ? languagelist.free : languagelist[this.props.promotiondetail.payment_mode]} </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-lg-6 with_sep">
                                        <ul className="budget_list">
                                            <li>
                                                <img src="/assets/images/price_icon.png" /> {languagelist.remainbudget}
                                                <br/>
                                                <a href="#" className="addnew_btn">${this.props.promotiondetail.remaining_budget}  {languagelist.budgetleft}</a>
                                               
                                            </li>
                                           
                                           {/*  <li>
                                                <img src="/assets/images/click_icon.png" />
                                                <a href="#" className="addnew_btn">{this.props.promotiondetail.total_user} {languagelist.targetuser}</a>
                                            </li> */}
                                            <li>
                                                <img src="/assets/images/click_icon.png" /> {languagelist.noview}
                                                <br/>
                                                <a href="#" className="addnew_btn">{this.props.promotiondetail.total_reach} {languagelist.clicks}</a>
                                               
                                            </li>
                                           
                                            <li>
                                                <img src="/assets/images/reported_icon.png" /> {languagelist.reportedp}
                                                <br/>
                                                <a href="#" className="addnew_btn">{this.props.promotiondetail.no_of_report} {languagelist.reported}</a>
                                               
                                            </li>
                                           
                                            <div className="clearfix"></div>
                                        </ul>
                                       
                                    </div>

                                </div>
                                <div className="clr20"></div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="clr20" />
                    {((this.props.promotiondetail.payment_status == 'Unpaid') && (this.props.currentUserDetails.user.id == this.props.promotiondetail.promotion_creator_id)) ?
                        <div className="text-center promotion_btn">
                             <div className="col-lg-3" style={{display:this.state.custom_display}}>&nbsp;</div> 
                             {
                                 (this.props.promotiondetail.payment_mode == 'EVC_wallet') ? 
                                    <div className={(this.state.custom_display == 'none') ? "col-lg-6" : "col-lg-6"} >
                                        <a href={void(0)} className="btn_5" onClick={this.openModal}>{languagelist.payoptn1}</a> 
                                    </div> 
                                :   
                                    (this.props.promotiondetail.payment_mode != 'Cash') ? 
                                        <div className={(this.state.custom_display == 'none') ? "col-lg-12" : "col-lg-9"} >
                                            <a href={void(0)} className="btn_5" onClick={this.payNow}>{languagelist.payoptn2}</a> 
                                        </div>
                                    : null
                             }
                            
                           
                           {/*  <div className={(this.state.custom_display == 'none') ? "col-lg-6" : "col-lg-6"} >
                                <a href={void(0)} className="btn_5" onClick={this.openModal}>Pay with EVC Wallet</a> 
                            </div> */}
                        </div>
                    : null
                    }
                   
                </div>
                : null
                        
            }
               <WalletConnection modalOpen={this.state.modal} closeModal={this.closeModal} evcpayment={this.evcpayment}/>          
            </div>  
        );
  }
}
const mapStateToProps = state => {
  return {
    
    promotiondetail    : state.promotiondetail.promotionDetail,   
    currentUserDetails : state.login,      
    evc                : state.wallet.walletReply
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getPromotionDetail   : bindActionCreators(getPromotionDetail, dispatch),
    evcwalletPayment     : bindActionCreators(evcwalletPayment, dispatch),
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PromotionDetail));